import { useState } from "react";
import { useNavigate } from "react-router-dom";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Logo from "../../assets/images/logo.png";
import { useSnackbar } from "notistack";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import { _admin_login_api } from "../../DAL/adminAuth/auth";
import {
  _set_token_in_localStorage,
  _set_user_in_localStorage,
} from "../../localStorage/localStorage";
import { useAdminContext } from "../../hooks/AdminContext";

export default function LoginForm() {
  const { enqueueSnackbar } = useSnackbar();
  const { setUserInfo } = useAdminContext();

  const [passwordVisible, setPasswordVisible] = useState(false);
  const [loading, setLoadsing] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [inputs, setInputs] = useState({
    email: "",
    password: "",
  });
  const navigate = useNavigate();

  const handleChange = (e) => {
    setInputs({ ...inputs, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let postData = {
      email: inputs.email,
      password: inputs.password,
    };
    setLoadsing(true);
    const result = await _admin_login_api(postData);
    console.log(result, "resultresult");
    if (result.code === 200) {
      _set_token_in_localStorage(result.token);
      _set_user_in_localStorage(result?.user);
      localStorage.setItem("user", JSON.stringify(result.user));
      setUserInfo(result.user);
      enqueueSnackbar(result.message, { variant: "success" });
      setLoadsing(false);

      navigate(`/dashboard`, { replace: true });
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setLoadsing(false);
    }
  };

  return (
    <div className="pageContainer">
      <div className="form-container">
        <div className="form-content">
          <h2 className="sign-in-title">Sign In</h2>
          <form onSubmit={handleSubmit} className="form">
            <div className="mt-3">
              <TextField
                fullWidth
                required
                label="Email"
                name="email"
                type="email"
                value={inputs.email}
                onChange={handleChange}
              />
            </div>
            <div className="mt-3">
              <TextField
                fullWidth
                required
                label="Password"
                name="password"
                type={passwordVisible ? "text" : "password"}
                value={inputs.password}
                onChange={handleChange}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setPasswordVisible(!passwordVisible)}
                        edge="end"
                      >
                        {passwordVisible ? (
                          <VisibilityOffOutlinedIcon fontSize="small" />
                        ) : (
                          <VisibilityOutlinedIcon fontSize="small" />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </div>
            <div className="forgot-password-container mt-2">
              <div
                onClick={() => {
                  navigate(`/forgot-password`);
                }}
                className="forgot-password-link pointer"
              >
                Forgot Password?
              </div>
            </div>
            <Button
              type="submit"
              className="mui-button "
              disabled={isLoading}
              variant="contained"
              fullWidth
            >
              {loading ? "loading..." : "Login"}
            </Button>
          </form>
        </div>
      </div>
      <div className="logoContainer">
        <div className="logoContent">
          <img src={Logo} alt="new" className="logoImage" />
          <h2 className="logoTitle">Welcome, Admin</h2>
          <p>Manage your community and users effectively.</p>
        </div>
      </div>
    </div>
  );
}
